// Resolver ikon pro agendy — mapuje volitelný `icon` string z agenda configu
// na konkrétní ikonovou komponentu. Většina jmen míří na Lucide ikony; entity
// plánovače (folder/box/chain/users) reusují přímo ikony tree-view, aby hlavička
// okna používala TU SAMOU ikonu jako strom. Nemapované hodnoty (i undefined)
// fallbackují na neutrální výchozí ikonu, takže každá agenda má vždy ikonu.

import type { ComponentType, SVGProps } from 'react';
import {
  Globe,
  MapPin,
  Calendar,
  CalendarDays,
  FolderOpen,
  FolderTree,
  File,
  FileText,
  Package,
  User,
  Settings,
  List,
  ListChecks,
  LayoutGrid,
  Briefcase,
  ClipboardList,
  Route,
  SquareDashed,
  Box,
} from 'lucide-react';

import { TreeFolderIcon, TreeBoxIcon, TreeChainIcon, TreeUsersIcon } from '@/shared/ui/tree-view';

// Tree ikony mají signaturu `{ className? }`, Lucide `SVGProps` — obojí je přiřaditelné
// do tohoto širšího typu (konzumenti předávají jen `className`/`aria-hidden`).
type IconComponent = ComponentType<SVGProps<SVGSVGElement>>;

const ICON_MAP: Record<string, IconComponent> = {
  globe: Globe,
  'map-pin': MapPin,
  calendar: Calendar,
  'calendar-days': CalendarDays,
  // Entity plánovače — tytéž ikony jako v tree-view.
  folder: TreeFolderIcon,
  box: TreeBoxIcon,
  chain: TreeChainIcon,
  users: TreeUsersIcon,
  'folder-open': FolderOpen,
  'folders-tree': FolderTree,
  'folder-tree': FolderTree,
  file: File,
  'file-text': FileText,
  package: Package,
  user: User,
  settings: Settings,
  list: List,
  'list-checks': ListChecks,
  'layout-grid': LayoutGrid,
  briefcase: Briefcase,
  'clipboard-list': ClipboardList,
  route: Route,
  'square-dashed': SquareDashed,
};

/** Výchozí fallback – box glyph (3D krabice), shodně s design systémem
 *  (`IconBox`): agenda bez vlastní ikony dostane box. */
const DEFAULT_ICON: IconComponent = Box;

export function resolveAgendaIcon(name: string | undefined): IconComponent {
  if (!name) return DEFAULT_ICON;
  return ICON_MAP[name] ?? DEFAULT_ICON;
}
